export default "__VITE_ASSET__ByK1YEYp__"